export default __webpack_public_path__ + "ea1725d031ed44aee4bd186a72b3f1b9.png";